<app-header title="Manage Campaigns"></app-header>
<ng-container [formGroup]="option">
    <div>
      <div class="card__title mb-4">Option image</div>
      <div class="row">
        <div class="col-8">
          <div _ngcontent-ng-c1220136012="" class="body-1 mb-1">Item Image(s)</div>
          <div mdbSortableContainer class="image-sortable-list d-flex flex-wrap" (itemDrop)="onDrop($event)">

            @for (image of optionImages; track image;let i = $index) {
              <div mdbDraggable  class="image-sortable-item">
                <div
                  style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                  class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                >
                  <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="onRemoveImage(i)"></app-icon-delete>
                </div>
                <img [src]="image" alt=""  style="border-radius: 5px">
              </div>
            }
            <div class="d-flex flex-column align-items-center">
              <div style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;" class="image-sortable-item">
                <app-input-file multiple="true" class="position-absolute" [classes]="['btn--paybee-custom']" label="Upload" accept="image/png,image/jpeg" formControlName="additionalImageFile"></app-input-file>
              </div>
                <span  class="d-block blue-text body-2 text-center">OR</span>
              <a (click)="openChooseImageModal(0)" class="blue-text body-2 mb-2">Choose from previously used images</a>
            </div>
    
          </div>
        </div>
        <div class="col-4 d-flex align-items-center flex-column " style=" border-left: 1px solid rgba(0,0,0,.07);">
            <div class="d-flex flex-row align-items-center">
              <div class="body-1 mr-1">Thumbnail</div>
              <i data-toggle="tooltip" data-placement="left" title="This will be seen by donors viewing this campaign on mobile phones" class="blue-text far fa-question-circle"></i>
            </div>
           
            <div class="image-block mb-1 mt-3 w-50 d-flex justify-content-center">
              @if(option.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                  <div class="image-block__file-container d-flex align-items-center justify-content-center" style="width: 80%;height:80%">
                      <app-input-file formControlName="thumbnailFile" [classes]="['btn--paybee-custom']" [minSize] ='200' class="position-absolute" label="Upload" accept="image/png,image/jpeg"></app-input-file>
                  </div>
              }
              @if(option.controls.thumbnailDataUrl.value !== '/images/blank_1x1.png'){
                  <div class="image-block__file-container d-flex align-items-start justify-content-end">
                      <app-icon-delete (click)="resetImageByType('thumbnail')" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                  </div>
              }
              <img class="image-block__image" [src]="option.controls.thumbnailDataUrl.value">
            </div>
            @if(option.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
              <span  class="d-block blue-text body-2 text-center">OR</span>
              <a (click)="openChooseImageModal(1)" class="d-block blue-text body-2 text-center">Choose from previously used images</a>
              <div  [ngStyle]="{'display': chooseImageModalShow ? 'none' : 'flex'}" class=" flex-row align-items-center">
                <a (click)="generateThumbnail()" class="blue-text body-2 mr-1 text-center">Generate Thumbnail from main image</a>
                <!-- <app-text-popover
                    placement="bottom"
                    type="content"
                    text="Generates a thumbnail from the item image"
                    title=""
                  >
                  </app-text-popover> -->
                  <!-- <i data-toggle="tooltip" data-placement="left" title="Generates a thumbnail from the item image" class="blue-text far fa-question-circle"></i> -->
              </div>
            }
    
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-mdb-switch label="Add Video For Item" formControlName="addVideo"></app-mdb-switch>
          @if(option.value.addVideo){
            <div class="row justify-content-left">
              <div class="w-75">
                <mdb-form-control class="form-fill">
                  <mdb-select formControlName="videoProvider" data-panel="stream" (valueChange)="resetVideoUrl()"  class="mdb-select" [(ngModel)]="videoProviderSelected">
                    @for (videoProvider of videoProviderService.list; track videoProvider.id) {
                      <mdb-option [value]="videoProvider.value">{{ videoProvider.label }}</mdb-option>
                    }
                  </mdb-select>
                  <label mdbLabel class="form-label form-label--paybee">Select Item Video Type</label>
                </mdb-form-control>
              </div>
  
              <div class="help-icon ml-3">
                @if(videoProviderSelected === 0){
                  <app-text-popover
                  placement="bottom"
                  type="video-help"
                  title="Help"
                >
                  <div class="col-12 video-help">
                    <span>Please make sure that video url is embeddable on third party sites.</span>
                  </div>
                  </app-text-popover>
                }

                @if(videoProviderSelected === 1){
                  <app-text-popover
                  placement="bottom"
                  type="video-help"
                  title="Help"
                >
                  <div class="col-12 video-help">
                    <div><strong>Finding the embed code on YouTube:</strong></div>
                    <ol>
                      <li>Go to YouTube.</li>
                      <li>Navigate to the video you wish to embed.</li>
                      <li>Click the Share link below the video, then click the Embed link.</li>
                      <li>The embed link will be highlighted in blue. You will need to copy this link in order to add it to your page in the Employer Center.</li>
                    </ol>
                  </div>
                  </app-text-popover>
                }

                @if(videoProviderSelected === 2){
                  <app-text-popover
                  placement="bottom"
                  type="video-help"
                  title="Help"
                >
                  <div class="col-12 video-help">
                    <div><strong>Finding the embed code on Vimeo:</strong></div>
                    <ol>
                      <li>Go to Vimeo.</li>
                      <li> Navigate to the video you wish to embed.</li>
                      <li>Click the Share button, in the top right corner of your video.</li>
                      <li>A pop-up will appear with the embed link information. You will need to copy only the src</li>
                    </ol>
                  </div>
                  </app-text-popover>
                }

                @if(videoProviderSelected === 3){
                  <app-text-popover
                  placement="bottom"
                  type="video-help"
                  title="Help"
                >
                  <div class="col-12 video-help">
                    <div><strong>Finding the embed code on Facebook:</strong></div>
                    <ol>
                      <li>Open Facebook on a computer.</li>
                      <li>Go to the video you want to embed.</li>
                      <li>Click and select Embed. Keep in mind that you will only see this item if the video's audience is set to Public.</li>
                      <li>Copy link from the code that appears and paste it here.
                    </ol>
                  </div>
                </app-text-popover>
                }
              </div>
  
              <div class="col-12">
                <mdb-form-control class="form-fill">
                  <app-mdbp-input mdbInput formControlName="videoUrl" maxLength="512" label='Enter The Item Video Embed Link'></app-mdbp-input>
                </mdb-form-control>
              </div>
  
            </div>
          }

        </div>
      </div>
      <div class="divider mb-4"></div>

      <div class="row mb-5">
          <div class="col-8">
              <mdb-form-control class="form-fill" >
                  <app-mdbp-input mdbInput formControlName="name"  label='Item Name'></app-mdbp-input>
                  @if(option.controls.name.hasError('required') && option.controls.name.touched ){<mdb-error class="form-fill-error" >Please provide Name</mdb-error>}
              </mdb-form-control>
          </div>
          <div class="col-4 d-flex">
              <mdb-form-control class="form-fill" >
                  <app-mdbp-input mdbInput formControlName="count" [isCurrencyMask]="true" label='Total Item Count'>
                      <input  #inputNameC currencyMask formControlName="count"  [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" class="form-control form-control--paybee"/>
                      @if(isMultiple() && option.controls.count.value <= 10000 ){<span class="mdb-input-span">{{option.get('count').value}} winners will be chosen at the close.</span>}
                      <div class="d-flex group-ticket-info__container px-2 py-1 position-absolute" style="width: fit-content;font-size: 12px; padding-left: 14px!important; height: 28px;" 
                        [ngStyle]="{'margin-top': isMultiple() && option.controls.count.value <= 10000 || option.controls.count.hasError('required') && option.controls.count.touched || option.controls.count.value > 10000  ?
                        '40px':'10px'}">
                        <div class="group-ticket-info__content " style="font-weight: 400;">
                          {{getSoldAuction()}}
                        </div>
                      </div>
                  </app-mdbp-input>
                  @if(option.controls.count.hasError('required') && option.controls.count.touched){<mdb-error class="form-fill-error">Please provide "Total Item Count"</mdb-error>}
                  @if(option.controls.count.value > 10000 ){<mdb-error class="form-fill-error">Please provide "Total Item Count" from 0 to 10 000 </mdb-error>}
              </mdb-form-control>
              @if(isSilentAuction()){
                <div class="d-flex align-items-center ml-2 h-100" style="width:100px;">
                  <app-text-popover
                    size="sm"
                    placement="bottom"
                    type="content"
                    text="If set more than one, multiple winners may be awarded at the close."
                    title="Help"
                  >
                  </app-text-popover>
                </div>
              }

          </div>
      </div>
      @if(!option.controls.buyItNowOnlyItem.value){
        <div class="row">
          <div class="col-8">
              <mdb-form-control class="form-fill" >
                  <app-mdbp-input mdbInput formControlName="minBid" [isCurrencyMask]="true" label='Min Bid'>
                      <input  #inputNameC currencyMask formControlName="minBid" class="form-control form-control--paybee"/>
                  </app-mdbp-input>
                  @if(option.controls.minBid.hasError('required') && option.controls.minBid.touched){<mdb-error class="form-fill-error">Please provide Min Bid amount</mdb-error>}
                  @if(option.controls.minBid.hasError('min') && option.controls.minBid.touched){<mdb-error class="form-fill-error">Please provide Min Bid more than 0</mdb-error>}
                  @if(option.controls.minBid.hasError('max') && option.controls.minBid.touched){<mdb-error class="form-fill-error">Allowed Min Bid from $1 to {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }}</mdb-error>}
              </mdb-form-control>
          </div>
          <div class="col-4">
              <mdb-form-control class="form-fill">
                  <app-mdbp-input mdbInput formControlName="bidIncrement" [isCurrencyMask]="true"  label='Bid Increment'>
                      <input  #inputNameC currencyMask formControlName="bidIncrement"  class="form-control form-control--paybee"/>
                  </app-mdbp-input>
                  @if(option.controls.bidIncrement.hasError('required') && option.controls.bidIncrement.touched){<mdb-error class="form-fill-error">Please provide Bid Increment amount</mdb-error>}
                  @if(option.controls.bidIncrement.hasError('min') && option.controls.bidIncrement.touched){<mdb-error class="form-fill-error">Please provide Bid Increment amount more than 0</mdb-error>}
                  @if(option.controls.bidIncrement.hasError('max') && option.controls.bidIncrement.touched){<mdb-error class="form-fill-error">Allowed Bid Increment amount from $1 to {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }}</mdb-error>}
              </mdb-form-control>
          </div>
        </div>
      }

      <div class="row">
          <div class="col-8">
              <mdb-form-control class="form-fill">
                  <app-mdbp-input mdbInput formControlName="valueProvided" [isCurrencyMask]="true" label='Value of goods or services provided, If any!'>
                      <input  #inputNameC currencyMask formControlName="valueProvided" [options]="{'precision': 2}" class="form-control form-control--paybee"/>
                  </app-mdbp-input>
                  @if(option.controls.valueProvided.hasError('max') && option.controls.valueProvided.touched){<mdb-error class="form-fill-error">Allowed value to {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }}</mdb-error>}
              </mdb-form-control>
          </div>
          <div class="col-4">
            <div class="d-flex align-items-center ml-2 h-100">
              <app-text-popover
                placement="bottom"
                type="learn-more"
                title="Learn more"
              >
              </app-text-popover>
            </div>
          </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-mdb-switch label="Any additional info required" formControlName="additionalInfoRequired"></app-mdb-switch>
          @if(option.value.additionalInfoRequired){
            <div style="padding-left: 44px;">
              <mdb-form-control class="form-fill" data-panel="general">
                  <app-mdbp-input mdbInput formControlName="additionalInfoDesc" data-panel="general" label='Additional info description'></app-mdbp-input>
                  @if(option.controls.additionalInfoDesc.hasError('required') && option.controls.additionalInfoDesc.touched){<mdb-error class="form-fill-error">Please provide Description</mdb-error>}
              </mdb-form-control>
              <div class="position-relative mb-4">
                  <label class="form-check-label form-check-label--paybee mb-1">Instructions for additional info (optional)</label>
                  <mdb-form-control class="mb-4">
                      <app-quill-custom mdbInput formControlName="additionalInfoDetail" limit="2048"></app-quill-custom>
                  </mdb-form-control>     
              </div>
              @if(option.controls.additionalInfoDetail.invalid){<span class="form-fill-error" style="margin-top: -20px;">Invalid link</span>}
          </div>
          }

        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <app-mdb-switch label="Any additional info, to be selected by user" formControlName="additionalInfoSelectRequired"></app-mdb-switch>
          <div style="padding-left: 44px;" [ngClass]="additionalInfoSelectRequiredClassess">
            <mdb-form-control class="form-fill" data-panel="general">
                <app-mdbp-input mdbInput formControlName="additionalInfoSelectDesc" data-panel="general" label='Additional info select description'></app-mdbp-input>
                @if(option.controls.additionalInfoSelectDesc.hasError('required') && option.controls.additionalInfoSelectDesc.touched){<mdb-error class="form-fill-error" >Please provide Description</mdb-error>}
            </mdb-form-control>
            <p class="mb-0 grey-text small"> Type a option and press enter to add. Click <strong>X</strong> to remove it. </p>
            <app-chips
                 placeholder="Press Enter to add each Tag"
                 formControlName="additionalInfoSelect"
                 [touched]="additionalInfoSelect.touched"
                 [required]="option.value.additionalInfoSelectRequired"
                 idChips="additionalInfoSelect"
            ></app-chips>
          </div>
        </div>
      </div>
      
      @if(formGroupCampaignTypeData.value.auctionType === 0){
        <div class="row">
          <div class="col-12">
              <app-mdb-switch label="Buy It Now ONLY item (Bid button will be hidden)" formControlName="buyItNowOnlyItem"></app-mdb-switch>
          </div>
      </div>
      <div class="row">
          <div class="col-12">
              <app-mdb-switch label="Enable Buy It Now" formControlName="buyItNowEnabled"></app-mdb-switch>
              @if(option.value.buyItNowEnabled){
                <div style="padding-left: 44px;">
                  <mdb-form-control class="form-fill" >
                      <app-mdbp-input mdbInput formControlName="buyItNowAmount" [isCurrencyMask]="true" label='Buy it Now Amount'>
                          <input  #inputNameC currencyMask formControlName="buyItNowAmount"  class="form-control form-control--paybee"/>
                      </app-mdbp-input>
                      @if(option.controls.buyItNowAmount.hasError('required') && option.controls.buyItNowAmount.touched){<mdb-error class="form-fill-error">Please provide Buy it Now Amount</mdb-error>}
                      @if(option.controls.buyItNowAmount.hasError('min') && option.controls.buyItNowAmount.touched){<mdb-error class="form-fill-error">Please provide Buy it Now Amount more than 0</mdb-error>}
                      @if(option.controls.buyItNowAmount.hasError('max')  && option.controls.buyItNowAmount.touched){<mdb-error class="form-fill-error">Allowed Buy it Now Amount from $1 to {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }}</mdb-error>}
                  </mdb-form-control>
              </div>
              }
          </div>
      </div>
      }
      <div class="divider"></div>
      <div class="row">
          <div class="col-12">
              <app-mdb-switch label="Collect Sales Tax For This Item" formControlName="collectSalesTax"></app-mdb-switch>
              @if(option.value.collectSalesTax){
                <div style="padding-left: 44px;">
                  <mdb-form-control class="form-fill">
                      <app-mdbp-input mdbInput formControlName="salesTax" [isCurrencyMask]="true" label='Percentage Sales Tax'>
                          <input  #inputNameC currencyMask [options]="{ precision: 2, allowNegative: false, prefix: '' }" formControlName="salesTax"  class="form-control form-control--paybee"/>
                      </app-mdbp-input>
                      @if(option.controls.salesTax.hasError('required') && option.controls.salesTax.touched){<mdb-error class="form-fill-error">Please provide correct Percentage Sales Tax from 0.01 to 100</mdb-error>}
                      @if(option.controls.salesTax.value > 100){<mdb-error class="form-fill-error">Please provide correct Percentage Sales Tax from 0.01 to 100</mdb-error>}
                  </mdb-form-control>
              </div>
              }
          </div>
      </div>

      <div class="divider"></div>

      <div class="row mt-4" [ngClass]="option.value.donatedByName ? 'mb-0' : 'mb-4'">
        <div class="col-12">
          <mdb-form-control class="form-fill mb-0">
            <app-mdbp-input (keyup)="onChangeDonatedBy($event)" mdbInput  maxLength="64" formControlName="donatedByName" label='Donated by: '></app-mdbp-input>
          </mdb-form-control>
        </div>
        @if(option.value.donatedByName){
          <div class="col-12">
            <app-mdb-switch label="Display Item Donor To Bidders" formControlName="displayDonatedBy"></app-mdb-switch>
          </div>
        }
      </div>

      <div class="divider"></div>

      <div class="row" [ngClass]="option.value.itemCode ? 'mb-0' : 'mb-4'">
        <div class="col-8">
          <mdb-form-control class="form-fill mb-0">
            <app-mdbp-input (keyup)="onChangeItemCode($event)" mdbInput maxLength="32" formControlName="itemCode" label='Item Code (Optional)'></app-mdbp-input>
          </mdb-form-control>
        </div>
        @if(option.value.itemCode){
          <div class="col-12">
            <app-mdb-switch label="Display Item Code To Bidders" formControlName="displayToDonors"></app-mdb-switch>
          </div>
        }
      </div>

      <div class="divider mb-4"></div>

        <div class="row">
          <div class="col-12">
            <app-mdb-switch label="Mark As Featured Item" formControlName="featured"></app-mdb-switch>
          </div>
        </div>

        <div class="divider"></div>
        <div class="row mt-4">
            <div class="col-12">
                <div>Add one or more category.</div>
                <p class="mb-0 grey-text small">
                    Type a category name and press enter to add. Click <strong>X</strong> to remove it.
                </p>
                <app-chips-autocomplete label="Categories" formControlName="categories" [optCategories]="optCategories"></app-chips-autocomplete>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="position-relative mb-4">
                  <div class="d-flex flex-row align-items-center mb-1">
                    <label class="form-check-label form-check-label--paybee mr-2">Description</label>
                    <app-text-popover
                        placement="bottom"
                        type="content"
                        text="Add a detailed description to describe this item. This is displayed when donors tap on the Details button when viewing the list of items in this campaign."
                        title=""
                    >
                    </app-text-popover>
                </div>
                    <mdb-form-control>     
                      <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
                    </mdb-form-control>
                </div>
            </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
              <div class="position-relative mb-4">
                  <div class="d-flex align-items-center mb-2">
                    <div class="d-flex flex-row align-items-center mb-1">
                      <label class="form-check-label form-check-label--paybee mr-2">Summary</label>
                      <app-text-popover
                          placement="bottom"
                          type="content"
                          text="Add a short summary to describe this item. This is displayed when donors are viewing the list of items in this campaign."
                          title=""
                      >
                      </app-text-popover>
                    </div>
                    @if(option.get('desc').value !== ''){
                      <div class="d-flex justify-content-end w-100">
                        <a (click)="generateSummary(0)" class="blue-text body-2">Generate Summary From Description</a>
                    </div>
                    }
                  </div>
                  <mdb-form-control>     
                    <app-quill-custom mdbInput formControlName="summary" [options]="quillOptions" limit="256"></app-quill-custom>
                  </mdb-form-control>
              </div>
          </div>
      </div>
      <div class="row">
        <mdb-accordion-item [collapsed]="!accordionService.map.optionLiveTime.expanded" (itemShown)="accordionService.onAfterExpand('optionLiveTime')" (itemHidden)="accordionService.onAfterCollapse('optionLiveTime')">
          <ng-template mdbAccordionItemHeader>Option Start/End Date</ng-template>
          <ng-template mdbAccordionItemBody>
              <div class="body-1 mb-2">Date set here controls if option will be visible to users.</div>
              <div class="row">
                  <div class="col-12">
                      <app-datetime
                          dateLabel="Start Date"
                          timeLabel="Start Time"
                          formControlName="optionStartDate"
                          [myDatePickerOptions]="auctionStartTimeOptions"
                          [submitted]="campaignOptionFormService.submitted"
                          data-panel="optionLiveTime"
                      ></app-datetime>
                  </div>
                  <div class="col-12">
                      <app-datetime
                          dateLabel="Stop Date"
                          timeLabel="Stop Time"
                          formControlName="optionEndDate"
                          [myDatePickerOptions]="auctionEndTimeOptions"
                          [submitted]="campaignOptionFormService.submitted"
                          data-panel="optionLiveTime"
                      ></app-datetime>
                  </div>
              </div>
          </ng-template>
      </mdb-accordion-item>
      </div>
        <div class="row mt-4">
            <div class="col-12">
                <mdb-form-control class="form-fill textarea-control"  >
                    <app-mdb-textarea mdbInput formControlName="memo" maxLength="2048"  label="Memo (Optional, only visible to your account admins)"></app-mdb-textarea>
                </mdb-form-control>
            </div>
        </div>
    </div>
</ng-container>
